import { Dispatch, JSX, SetStateAction } from 'react';
import { SearchType } from '../../assistantSearchTypes';
import { SearchStateProps } from '../../Assistant';
import { AssistantListItemSelectionStateProps } from '../../drawer/hooks/useAssistantListItemSelectionHandler';
import { useSummaryCustomerHook } from './useSummaryCustomerHook';

export interface SummarySearchTypeHookProps {
    searchType: SearchType;
    itemId: string;
    enterpriseIds: string[];
    handleCloseSummarySidePanel: () => void;
    setSearchState: Dispatch<SetStateAction<SearchStateProps>>;
    setListItemSelectionState: Dispatch<SetStateAction<AssistantListItemSelectionStateProps>>;
    summaryPanelOpened: boolean;
}

export interface SummarySearchTypeHookResult {
    component: JSX.Element | null;
    actions?: JSX.Element | null;
    title: string;
}

export const useSummarySearchTypeHook = ({
    searchType,
    itemId,
    enterpriseIds,
    handleCloseSummarySidePanel,
    setSearchState,
    setListItemSelectionState,
    summaryPanelOpened,
}: SummarySearchTypeHookProps): SummarySearchTypeHookResult => {
    const customer = useSummaryCustomerHook({
        itemId,
        enterpriseIds,
        handleCloseSummarySidePanel,
        setSearchState,
        setListItemSelectionState,
        summaryPanelOpened,
    });

    switch (searchType) {
        case SearchType.Customer:
            return customer;
        default:
            return {
                component: null,
                title: '',
            };
    }
};
